import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const Container = styled.div`
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  padding: 1rem;
  margin: 0 0 1rem;
  width: 100%;

  ${({ theme, themeColor, backgroundColor }) => css`
    color: ${theme.themeColors[themeColor]};
    border-color: ${theme.themeColors[themeColor]};
    background-color: ${backgroundColor};
  `};
`;

function Alerts({ themeColor, children, className, backgroundColor }) {
  return (
    <Container
      themeColor={themeColor}
      className={className}
      backgroundColor={backgroundColor}
    >
      {children}
    </Container>
  );
}

Alerts.propTypes = {
  themeColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  className: PropTypes.string,
};

Alerts.defaultProps = {
  themeColor: "primary",
  backgroundColor: "#fff",
  className: "",
};

export default Alerts;
